/**
 * ON DOCUMENT LOADED
 */
document.addEventListener('DOMContentLoaded', function () {
    console.debug('INFO pagedisclaimer.js loaded')
    var bronsonDisclaimerPage = bronson.$$('#id-disclaimer-page')
    if (bronsonDisclaimerPage.length === 1) {
        bronsonDisclaimerPage.component('modal').items[0].open()
    }
})
